import { useEditorState } from '@/state/editorState.ts';
import { useMemo } from 'react';

const useIsNewStep = (stepId?: string) => {
  const newStepId = useEditorState((s) => s.newStepId);

  return useMemo(() => !!(newStepId && newStepId === stepId), [newStepId, stepId]);
};

export default useIsNewStep;
